import FileImportContainers from 'components/FileImport/FileImportContainers'
import PageLayout from '../components/layout/PageLayout'
import ContainersList from 'components/lists/containers/ContainersList'

export default function ContainersPage() {
  return (
    <PageLayout 
    pageTitle='Contenedores' 
    pageDesc='Altas, bajas y modificaciones.'
    importButton={
      <FileImportContainers/>
    }
    >
      <ContainersList />
    </PageLayout>
  )
}